import { RouteItem } from '@eastcoal/router/types/route'

import {
  LISTING_DETAIL_PAGE_PATH,
  LISTING_LIST_PAGE_PATH,
  LISTING_RESULT_PAGE_PATH
} from './constants/path'

export const listingRoute: RouteItem = {
  title: '挂牌交易',
  hideChildrenInMenu: true,
  children: [
    {
      title: '挂牌列表',
      path: LISTING_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '挂牌详情',
      path: LISTING_DETAIL_PAGE_PATH,
      Component: () => import('./Detail')
    },
    {
      title: '下单成功',
      path: LISTING_RESULT_PAGE_PATH,
      Component: () => import('./Result')
    }
  ]
}
